export default "__VITE_ASSET__2kWygOmO__"